import { Component, inject } from '@angular/core';

import { MessageService } from 'primeng/api';
import { FileSelectEvent } from 'primeng/fileupload';
import { ImportService } from '../../services/import.service';
import { finalize } from 'rxjs';
import { ToasterService, TranslateService } from '@devinforius/i-essentials';
import { UploadResponse } from '@features/import/models/import.model';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  standalone: false,
  selector: 'app-import',
  templateUrl: './import.component.html',
  styleUrl: './import.component.scss',
  providers: [MessageService],
})
export class ImportComponent {
  private readonly messageService: MessageService = inject(MessageService);
  private readonly importService: ImportService = inject(ImportService);
  private readonly toasterService = inject(ToasterService);
  private readonly translateService = inject(TranslateService);

  file: File | null = null;
  uploading = false;
  uploadResponse: UploadResponse | null = null;

  constructor() {}

  onSelect(event: FileSelectEvent): void {
    this.uploadResponse = null;
    if (event.files && event.files.length > 0) {
      this.file = event.files[0];
    }
    if (
      event.files[0].name.split('.').pop() !== 'xlsx' &&
      event.files[0].name.split('.').pop() !== 'xls'
    ) {
      this.removeFile();
    }
  }
  onInvalidFile(): void {
    this.file = null;
    this.messageService.add({
      severity: 'error',
      summary: this.translateService.translate('global.error'),
      detail: this.translateService.translate(
        'import.fileValidation.invalidFileType'
      ),
      life: 3000,
    });
  }

  removeFile(): void {
    this.file = null;
    this.uploadResponse = null;
  }

  sendFile(): void {
    if (this.file) {
      this.uploading = true;
      this.importService
        .uploadExcelFile(this.file)
        .pipe(
          finalize(() => {
            this.uploading = false;
          })
        )
        .subscribe({
          next: (response: UploadResponse) => {
            this.toasterService.push(
              'success',
              this.translateService.translate('global.success'),
              this.translateService.translate(
                'import.fileValidation.uploadSuccess'
              )
            );
            this.uploadResponse = response;
            this.file = null;
          },
          error: (error: HttpErrorResponse) => {
            console.error('Upload error:', error);
            this.uploadResponse = {
              success: false,
              importedRecords: 0,
              message: error.error,
            };
            this.toasterService.push(
              'error',
              this.translateService.translate('global.error'),
              this.translateService.translate(
                'import.fileValidation.uploadError'
              )
            );
          },
        });
    }
  }
}
